import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { storage } from '@/lib/storage';

export interface Me {
  userId: string;
  nickname: string;
  level: number;
  score: number;
  isPremium: boolean;
  adminRole: string | null;
  profileImageUrl: string | null;
  onboardingDone: boolean;
}

interface AuthState {
  isLoggedIn: boolean;
  me: Me | null;
  // 첫 /users/me 응답이 도착했는지. 페이지 로드 시 false → AuthRefresher 가 true 로 전환
  // RequireAdmin/AuthGuard 가 이 플래그를 보고 라우트 결정 전에 대기
  authReady: boolean;
  setMe: (me: Me | null) => void;
  setAccessToken: (token: string) => void;
  setAuthReady: (ready: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      me: null,
      authReady: false,
      setMe: (me) => set({ me, isLoggedIn: !!me }),
      setAccessToken: (token) => {
        storage.set('accessToken', token);
      },
      setAuthReady: (ready) => set({ authReady: ready }),
      logout: () => {
        storage.remove('accessToken');
        set({ me: null, isLoggedIn: false });
      },
    }),
    {
      name: 'sisegonggan:auth',
      // authReady 는 persist 제외 — 매 로드마다 false 로 시작해 refresh 강제
      partialize: (state) => ({ me: state.me, isLoggedIn: state.isLoggedIn }),
    },
  ),
);
